import { Box, Card, CardContent, Grid, Stack, Typography } from "@mui/material";
import { AppWidgetSummary } from "../../../components/chart/charts";
import { CardDataType } from "src/types/types";
import Iconify from "src/components/iconify";
import { PRIMARY, WARNING } from "src/theme/palette";

const DashboardCards = ({ cards }: { cards: CardDataType[] }) => {
  const cardSize = cards?.length > 2 ? 2 : 12 / (cards?.length || 1);
  const Cards = cards?.map((card, index) => (
    <Grid key={card?.title} item xs={6} md={cardSize} display="flex" justifyContent="center">
      <Stack spacing={1} alignItems="center" textAlign="center">
        {card.icon && (
          <Box
            sx={{
              display: "flex",
              padding: 1,
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "50%",
              background: "rgba(167, 249, 249, 0.32)",
            }}
          >
            <Iconify icon={card.icon} color={index % 2 === 0 ? PRIMARY.dark : WARNING.main} width={24} height={24} />
          </Box>
        )}
        <Typography variant="body1" fontWeight="bold">
          {card.value}
        </Typography>
        <Typography variant="caption" color="text.disabled">
          {card.title}
        </Typography>
      </Stack>
    </Grid>
  ));
  return (
    <Card>
      <CardContent>
        <Grid item container spacing={3} xs={12}>
          {Cards}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default DashboardCards;
